export class ServiceDetails {
  firstName: string;
  lastName: string;
  contactNumber: string;
  contactNumberExtension: string;
  requestType: string;
  constructionSiteStatus: string;
  typicalInstallationTimeframe: string;
  requestInstallationOrder: string;
  closingDate: string;
  siteStatusUpdateDate: string;
  nextSiteStatusDueDate: string;
  buildingPointId: string;
  lookerStatus: string;
  esitmatedInstallDateofService: string;
  actualInstallDateofService: string;
  estimatedInstallDateofMeter: string;
  actualInstallDateofMeter: string;
  locate: string;
}
